import { render } from "./TravelGuideList.vue?vue&type=template&id=4b768e1f&scoped=true"
import script from "./TravelGuideList.vue?vue&type=script&lang=js"
export * from "./TravelGuideList.vue?vue&type=script&lang=js"

import "./TravelGuideList.vue?vue&type=style&index=0&id=4b768e1f&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b768e1f"]])

export default __exports__